import { render, staticRenderFns } from "./LearningCenter.vue?vue&type=template&id=1d332b3b"
import script from "./LearningCenter.vue?vue&type=script&lang=js"
export * from "./LearningCenter.vue?vue&type=script&lang=js"
import style0 from "./LearningCenter.vue?vue&type=style&index=0&id=1d332b3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports